import {TextView} from './TextView';


export {Text} from './Text';


export const textRegistrations = {
    'Text': TextView,
};
